module.exports = __webpack_public_path__ + "static/fonts/MuseoSans_500.62c01351.otf";